import { createFileRoute } from "@tanstack/react-router";
import SaintEs from "@/pages/es/SaintEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_SAINT_URL = `${SITE_URL}/es/saint`;

export const Route = createFileRoute("/es/saint")({
  head: () => ({
    meta: [
      {
        title: "SAINT® TMS para la Depresión | Neuro Wellness TMS",
      },
      {
        name: "description",
        content:
          "SAINT® TMS para la depresión resistente en Coral Springs, FL. Tratamiento acelerado de 5 días con fMRI. Consulta gratuita y verificación de seguro.",
      },
      {
        property: "og:title",
        content: "SAINT® TMS para la Depresión | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "SAINT® TMS de 5 días, guiada por fMRI, para la depresión resistente al tratamiento. Proveedor verificado en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_SAINT_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "SAINT® TMS para la depresión | Coral Springs, FL",
      },
      {
        name: "twitter:description",
        content:
          "SAINT® TMS de 5 días, guiada por fMRI, para la depresión resistente al tratamiento. Proveedor verificado en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_SAINT_URL },
      ...buildHreflang("/saint"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintEs />;
}
